/* eslint-disable */
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined'
import CloudUploadIcon from '@mui/icons-material/CloudUploadOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop'
import RIAppBar from '../AppBar'
import RIBreadcrumbsNav from '../RIBreadCrumbNav'
import '../../globalStyle.scss'
import ErrorContext, { SuccessContext } from '../../ErrorContext'
import Confirm from '../Confirm'
import { ConfirmContext } from '../../Confirm'
import ErrorSnackAlert from './ErrorSnackAlert'
import SuccessSnackAlert from './SuccessSnackAlert'
import { getAdminManagedResources } from '../../apiCalls/permissionApi'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderRole } from '../../utils/provider'

const PlatformLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { customerId } = useContext(OrgAppContext)
  const getSideBarOpenStatus = sessionStorage.getItem('sideBarOpenStatus')
  const parse = getSideBarOpenStatus === null ? {} : JSON.parse(getSideBarOpenStatus)
  const [open, setOpen] = useState<{ [key: string]: boolean }>(parse)
  const { isError, setIsError } = useContext(ErrorContext)
  const { isSuccess, setIsSuccess } = useContext(SuccessContext)

  const { isConfirmOpen, openConfirm, closeConfirm, confirmSettings } = useContext(ConfirmContext)
  const [isUserManagementDisplay, setIsUserManagementDisplay] = useState<boolean>(false)
  useEffect(() => {
    getAdminManagedResources({ customerId }).then((res: any) => {
      if (!res || !res?.data?.customers || res.error) {
        setIsUserManagementDisplay(false)
        return
      }
      setIsUserManagementDisplay(true)
    })
  }, [customerId])

  const handleToggleSubmenu = (text: string) => {
    const newStatus = JSON.stringify({
      ...open,
      [text]: !open[text],
    })
    sessionStorage.setItem('sideBarOpenStatus', newStatus)
    setOpen({
      ...open,
      [text]: !open[text],
    })
  }

  const navItems = [
    {
      text: 'Dashboard',
      icon: <SpaceDashboardOutlinedIcon />,
      path: '/',
    },
    {
      text: 'Alerts',
      icon: <PrivacyTipOutlinedIcon />,
      children: [
        { text: 'Alert Dashboard', path: '/alertDashboard' },
        { text: 'Alerts', path: '/alerts' },
        { text: 'Indicators', path: '/indicators' },
      ],
    },
    {
      text: 'Investigation',
      icon: <ScreenSearchDesktopIcon />,
      children: [
        { text: 'Investigation Dashboard', path: '/investigationDashboard' },
        { text: getProviderRole(customerId), path: '/provider' },
        { text: 'Client', path: '/client' },
      ],
    },
    {
      text: 'Upload',
      icon: <CloudUploadIcon />,
      path: '/upload',
    },
    {
      text: 'Setting',
      icon: <SettingsOutlinedIcon />,
      children: [
        { text: 'Organization Setting', path: '/organizationSetting' },
        { text: 'Detection Rules', path: '/detectionRules' },
        { text: 'EUBA Rules', path: '/eubaRules' },
      ],
    },
    ...(isUserManagementDisplay
      ? [
          {
            text: 'User Management',
            icon: <ManageAccountsOutlinedIcon />,
            path: '/userManagement',
          },
        ]
      : []),
    // {
    //   text: 'Breach Management',
    //   icon: <FolderOutlinedIcon />,
    //   path: '/breachManagement',
    // },
  ]

  const currentItem = useMemo(() => {
    const path = location.pathname
    for (const item of navItems) {
      if (item.path === path) {
        return item.text
      }
      if (item.children) {
        for (const child of item.children) {
          if (child.path === path) {
            return child.text
          }
        }
      }
    }
    return ''
  }, [location.pathname, navItems])

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  const handleCloseError = () => setIsError(false)
  const handleCloseSuccess = () => setIsSuccess(false)

  async function handleConfirm() {
    await confirmSettings.confirmCallback()
    closeConfirm()
  }

  return (
    <div
      style={{
        boxSizing: 'border-box',
        position: 'relative',
        overflowX: 'hidden',
        width: '100%',
      }}
    >
      <div
        style={{
          position: 'fixed',
          width: '100%',
          top: '0',
          zIndex: 9999,
        }}
      >
        <RIAppBar />
      </div>

      <div className='breadCrumb'>
        <RIBreadcrumbsNav />
      </div>

      <Grid container>
        <Grid
          item
          xs={0}
          md={2}
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
          }}
        >
          {/* Sidebar */}
          <Box
            sx={{
              height: '100vh',
              width: {
                xs: 0,
                md: '210px',
              },
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              top: '53px',
            }}
          >
            <List>
              {navItems.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    onClick={() => {
                      item.children ? handleToggleSubmenu(item.text) : handleNavigation(item.path!)
                    }}
                  >
                    <ListItemIcon
                      sx={item.text === currentItem ? { color: '#000000' } : { color: '#5B5B5B' }}
                    >
                      {item.icon}
                    </ListItemIcon>

                    <ListItemText
                      primary={item.text}
                      sx={{
                        ...(item.text === currentItem
                          ? { color: '#000000' }
                          : { color: '#5B5B5B' }),
                        '& .MuiTypography-root': {
                          fontSize: '15px',
                          fontWeight: '600',
                        },
                      }}
                    />
                    {item.children && (
                      <IconButton>
                        {open[item.text] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    )}
                  </ListItem>
                  {item.children && (
                    <Collapse in={open[item.text]} timeout='auto' unmountOnExit>
                      <List component='div' disablePadding>
                        {item.children.map((subItem, subIndex) => (
                          <ListItem
                            button
                            key={subIndex}
                            onClick={() => handleNavigation(subItem.path!)}
                            sx={{ pl: 4 }}
                          >
                            <ListItemText
                              primary={subItem.text}
                              sx={{
                                ...(subItem.text === currentItem
                                  ? { color: '#000000' }
                                  : { color: '#5B5B5B' }),
                                '& .MuiTypography-root': {
                                  fontSize: '14px',
                                  fontWeight: '600',
                                },
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              ))}
            </List>
          </Box>
        </Grid>

        <Grid
          item
          // xs={12}
          // md={10}
          sx={{
            marginTop: '114px',
            marginLeft: {
              md: '210px',
              xs: 0,
            },
            display: 'flex',
            justifyContent: 'center',
            minHeight: '80vh',
            width: 'calc(100vw - 210px)',
          }}
        >
          <Outlet />
          <ErrorSnackAlert open={isError} handleCloseError={handleCloseError} />
          <SuccessSnackAlert open={isSuccess} handleCloseError={handleCloseSuccess} />
          <Confirm
            isOpen={isConfirmOpen}
            text={confirmSettings.text}
            handleConfirm={handleConfirm}
            handleClose={closeConfirm}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default PlatformLayout
